(function () {
  "use strict";

  xlsMappingDnd.$inject = ['$timeout'];
  angular
    .module('trainerWebApp.directives')
    .directive('xlsMappingDnd', xlsMappingDnd);

  function xlsMappingDnd($timeout) {
    return function (scope, element, attrs) {
      var args = attrs.xlsMappingDnd.split(',');
      //console.log(args);

      var leftSideId = args[0];
      var leftSideItemClass = args[1];
      var leftSideModelName = args[2];
      var leftSideModel = scope.xlsState.unmatchedFields;
      var leftSideList = $('#' + leftSideId);

      var rightSideId = args[3];
      var rightSideItemClass = args[4];
      var rightSideItemModelName = args[5];
      var placeHolderCreationFunc = args[6];
      var placeHolderClass = args[7];

      var rightSideModel = scope.xlsState.matchedFields;
      var rightSideList = $('#' + rightSideId);

      var draggedItemIndex = -1;
      var draggedItem = null;

      var lastDeletedItem = new Array();

      $.widget("ui.sortable", $.extend({}, $.ui.sortable.prototype, {
        _rearrange: function (event, i, a, hardRefresh) {
          //console.log('draggedItem', draggedItemIndex, draggedItem.name);

          // sorting on the right-side
          if (i != null && $(i.item[0].parentNode).attr('id') == rightSideId) {
            //console.log('sorting right-side');

            if ($(i.item[0]).hasClass(rightSideItemClass) || $(this.currentItem).hasClass(rightSideItemClass)) {
              //console.log('sorting a right-side item on the right-side');

              // We have an item that was deleted before and the place holder is in the current list
              if (lastDeletedItem.length > 0 && (this.placeholder[0].parentNode == i.item[0].parentNode) && !$(this.currentItem).hasClass(rightSideItemClass)) {
                if (lastDeletedItem[lastDeletedItem.length - 1].item != null) {
                  i.item[0].parentNode.replaceChild(lastDeletedItem[lastDeletedItem.length - 1].item[0], this.placeholder[0]);
                } else {
                  i.item[0].parentNode.replaceChild(lastDeletedItem[lastDeletedItem.length - 1], this.placeholder[0]);
                }
                lastDeletedItem.pop();
              }

              if (!$(this.currentItem).hasClass(rightSideItemClass)) {
                //console.log('sorting a left-side item on the right-side');
                lastDeletedItem.push(i);
                i.item[0].parentNode.replaceChild(this.placeholder[0], i.item[0]);

              } else {
                i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction == 'down' ? i.item[0] : i.item[0].nextSibling))
              }
            }
            else {
              if (this.direction == 'down' && i.item[0].previousElementSibling == null && this.placeholder[0].parentNode == leftSideList[0]) {
                //console.log('bringing an item from the left-side - dragging down');
                i.item[0].parentNode.insertBefore(this.placeholder[0], i.item[0]);

                var theNextOne = i.item[0].nextElementSibling;
                while (!$(theNextOne).hasClass(rightSideItemClass)) {
                  theNextOne = theNextOne.nextElementSibling;
                }

                lastDeletedItem.push(theNextOne);
                i.item[0].parentNode.removeChild(theNextOne);
              } else if (this.direction == 'up' && i.item[0].nextElementSibling == null && this.placeholder[0].parentNode == leftSideList[0]) {
                //console.log('bringing an item from the left-side - dragging up');
                $('#' + rightSideId).append(this.placeholder[0]);

                var theLastOne = i.item[0].previousElementSibling;
                while (!$(theLastOne).hasClass(rightSideItemClass)) {
                  theLastOne = theLastOne.previousElementSibling;
                }

                lastDeletedItem.push(theLastOne);
                i.item[0].parentNode.removeChild(theLastOne);
              } else if (this.placeholder[0].parentNode == rightSideList[0]) {
                i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction == 'down' ? i.item[0] : i.item[0].nextSibling));
              }
            }
          }

          // sorting on left-side
          else if (i != null && $(i.item[0].parentNode).attr('id') == leftSideId) {
            //console.log('sorting left-side');

            if (!$(this.currentItem).hasClass(rightSideItemClass)) {
              //console.log('sorting from left-side to left-side');

              if (lastDeletedItem.length > 0 && (this.placeholder[0].parentNode == rightSideList[0])) {
                if (lastDeletedItem[lastDeletedItem.length - 1].item != null) {
                  rightSideList[0].replaceChild(lastDeletedItem[lastDeletedItem.length - 1].item[0], this.placeholder[0]);
                } else {
                  rightSideList[0].replaceChild(lastDeletedItem[lastDeletedItem.length - 1], this.placeholder[0]);
                }
                lastDeletedItem.pop();
              }

              i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction == 'down' ? i.item[0] : i.item[0].nextSibling));
            } else {
              //console.log('sorting from right-side to left-side');
              // TODO - are we sure this case is completely handled?
              i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction == 'down' ? i.item[0] : i.item[0].nextSibling))
            }

          } else if (i == null) {
            //console.log('item is null');

            if (lastDeletedItem.length > 0 && (this.placeholder[0].parentNode == rightSideList[0])) {
              if (lastDeletedItem[lastDeletedItem.length - 1].item != null) {
                rightSideList[0].replaceChild(lastDeletedItem[lastDeletedItem.length - 1].item[0], this.placeholder[0]);
              } else {
                rightSideList[0].replaceChild(lastDeletedItem[lastDeletedItem.length - 1], this.placeholder[0]);
              }
              lastDeletedItem.pop();
            }

            leftSideList.append(this.placeholder[0]);
          }

          this.counter = this.counter ? ++this.counter : 1;
          var self = this, counter = this.counter;

          $timeout(function () {
            if (counter == self.counter) {
              //Precompute after each DOM insertion, NOT on mousemove
              self.refreshPositions(!hardRefresh);
            }
          }, 10);
        }
      }));

      $('#' + leftSideId + ", #" + rightSideId).sortable({
        placeholder: 'drag-over-place-holder',
        connectWith: ".connectedSortable"
      });

//    scope.$watch(leftSideModelName, function (value) {
//      leftSideModel = value;
//    }, true);
//
//    scope.$watch(rightSideItemModelName, function (value) {
//      rightSideModel = value;
//    }, true);

      $('#' + leftSideId).sortable({
        start: function (event, ui) {
          draggedItemIndex = ($(ui.item).index());
          draggedItem = leftSideModel[draggedItemIndex];
          //console.log('dragging idx', draggedItemIndex, 'from the left');
        },
        stop: function (event, ui) {
          var newParentId = ui.item[0].parentNode.id;
          var newIndex = ($(ui.item).index());
          //console.log('left -> dragged idx', draggedItemIndex, 'to', newParentId, newIndex);

          leftSideModel.splice(draggedItemIndex, 1);

          // sorting within the left-side list
          if (newParentId == leftSideId) {
            leftSideModel.splice(newIndex, 0, draggedItem);
            applyChangesToScope();
            return;
          }

          var itemDroppedOn = rightSideModel[newIndex];

          // blow away whatever we dropped on on the right side
          rightSideModel.splice(newIndex, 1, draggedItem);

          // dropped on a field, move the field to the left
          if (!itemDroppedOn.placeHolder) {
            leftSideModel.splice(draggedItemIndex, 0, itemDroppedOn);
          }
          applyChangesToScope();
        },
        cancel: "." + placeHolderClass
      });

      $('#' + rightSideId).sortable({
        start: function (event, ui) {
          draggedItemIndex = ($(ui.item).index());
          draggedItem = rightSideModel[draggedItemIndex];
          //console.log('dragging idx', draggedItemIndex, 'from the right');
        },
        stop: function (event, ui) {
          var newParentId = ui.item[0].parentNode.id;
          var newIndex = ($(ui.item).index());
          //console.log('right -> stop: ', draggedItemIndex, 'to', newParentId, newIndex);

          rightSideModel.splice(draggedItemIndex, 1);

          // sorting within the right-side list
          if (newParentId == rightSideId) {
            rightSideModel.splice(newIndex, 0, draggedItem);
            applyChangesToScope();
            return;
          }

          // dragging to the left, replace the field with a placeholder and add it to the left
          var newPlaceHolder = scope[placeHolderCreationFunc]();
          rightSideModel.splice(draggedItemIndex, 0, newPlaceHolder);
          leftSideModel.splice(draggedItemIndex, 0, draggedItem);
          applyChangesToScope();
        },
        cancel: "." + placeHolderClass
      });

      function applyChangesToScope() {
        draggedItem = null;

        // https://github.com/angular/angular.js/pull/6016 defect
        var prevRight = rightSideModel.concat();
        var prevLeft = leftSideModel.concat();
        scope.xlsState.matchedFields = [];
        scope.xlsState.unmatchedFields = [];
        scope.$digest();

        scope.$apply(function () {
          scope.xlsState.matchedFields = prevRight;
          scope.xlsState.unmatchedFields = prevLeft;
        });
      }
    }
  }

})();
